<template>
	<div style="width: 100%;">
		<div class="contact">
			<div class="box" ref='contact'>
				<span v-show="contactShow" class="animate__animated animate__fadeInUp">联系我们，了解更多</span>
				<div class="btns" v-show="contactShow">
					<div class="btn animate__animated animate__fadeInUp" @click="change()">马上开通</div>
					<div class="btn animate__animated animate__fadeInUp" @click="change()">预约演示</div>
				</div>
			</div>
		</div>
		
		<div class="footer" ref='footer'>
			<div class="box">
				<div class="right">
					<div class="pic" >
						<img :src="imageHttp(info.wechat_code)" class="animate__animated animate__fadeInUp">
						<!-- <span class="animate__animated animate__fadeInUp">溜溜车友汇</span> -->
					</div>
					<!-- <div class="pic">
						<img src="../../../public/images/didiQr.jpg" class="animate__animated animate__fadeInUp">
						<span class="animate__animated animate__fadeInUp">嘀嘀来客</span>
					</div> -->
				</div>
				<div class="left">
					<div class="hotline animate__animated animate__fadeInUp">微信扫一扫联系客服</div>
					<!-- <div class="phone animate__animated animate__fadeInUp">400-900-1626</div> -->
					<div class="time animate__animated animate__fadeInUp">服务时间：{{info.service_time}}</div>
					<div class="citys animate__animated animate__fadeInUp">办公地址：{{info.address}}</div>
				</div>
				
			</div>
			<div class="btm" v-html="info.bottom_icp"> </div>
		</div>
		
		<register v-show="registerShow" @change='change' @add='add'></register>
	</div>
	
</template>

<script>
	import { indexBottomConfig,addClue } from '@/api'
	import { imageHttp } from '@/static/js/utils.js'
	import register from "@/components/register/index.vue"
	export default{
		data() {
			return{
				contactShow: false,
				info:{},								//网页底部信息
				registerShow:false,
			}
		},
		components:{
			register
		},
		mounted() {
			this.getBottomConfig()
			window.addEventListener("scroll", this.handleScroll);
			window.addEventListener("scroll", this.handle);
		},
		methods:{
			add(data){
				addClue(data).then(res => {
					if(res.code == 200){
						this.$toast('操作成功');
						console.log(res)
						this.registerShow = false
					}else{
						this.$toast(res.msg);
					}
				})
			},
			
			imageHttp,
			//网页底部配置
			getBottomConfig(){
				indexBottomConfig().then(res => {
					if(res.code == 200){
						// console.log(res)
						this.info = res.data.info
					}else{
						console.log(res.msg)
					}
					
				})
			},
			handleScroll () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'contact', show: 'contactShow'},
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gdjz(r.ref, 20, () => {
						_this[r.show] = true
					})
				})
			},
			gdjz(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c > a ) {
						callback && callback()
					}
				}
			},
			handle () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'contact', show: 'contactShow'},
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gd(r.ref, 20, () => {
						_this[r.show] = false
					})
				})
			},
			gd(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c < a ) {
						callback && callback()
					}
				}
			},
			// 是否打开注册弹框
			change(){
				console.log('2323')
				this.registerShow = !this.registerShow
			},
		}
	}
</script>

<style lang="scss" scoped>
	.contact{
		border-top: 0.55rem solid #fff;
		width: 100%;
		height: 2.61rem;
		background: url(../../../public/images/bj1.jpg)no-repeat center center;
		background-size: 1920px 2.61rem;
		
		.box{
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 0.44rem;
			color: #FFFFFF;
			margin-top: 0.64rem;
			
			.btns{
				display: flex;
				margin-top: 0.36rem;
				.btn{
					width: 1.79rem;
					height: 0.6rem;
					background: #FFFFFF;
					border-radius: 0.1rem;
					font-size: 0.24rem;
					color: #302828;
					line-height: 0.6rem;
					text-align: center;
				}
				.btn:nth-child(1){
					margin-right: 0.41rem;
				}
			}
		}
	}
	
	.footer{
		width: 100%;
		height: 2.6rem;
		background-color: #1C100B;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		
		.box{
			width: 12rem;
			height: 2.1rem;
			border-bottom: 0.01rem solid #6D6B6B;
			display: flex;
			
			.left{
				width: 6rem;
				height:2.1rem ;
				font-size: 0.18rem;
				
				.hotline{
					margin-top: 0.65rem;
					color: #CDCDCD;
				}
				.phone{
					margin-top: 0.25rem;
					font-size: 36px;
					color: #CDCDCD;
				}
				.time{
					margin-top: 0.42rem;
					color: #808080;
				}
				.citys{
					color: #808080;
					margin-top: 0.16rem;
				}
			}
			.right{
				// width: 6rem;
				height:2.1rem ;
				display: flex;
				justify-content: space-around;
				// margin-left: 2.39rem;
				.pic:nth-child(1){
					margin-right: 0.42rem;
				}
				.pic{
					width: 1.65rem;
					height: 2.02rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-top: 0.21rem;
					img{
						width: 1.65rem;
						height: 1.65rem;
						border: 0.01rem solid #999999;
					}
					span{
						font-size: 0.17rem;
						color: #808080;
						margin-top: 0.27rem;
					}
				}
			}
		}
		.btm{
			font-size: 0.14rem;
			color: #808080;
			margin-top: 0.1rem;
			 /deep/a{
				color: #808080;
			}
		}
	}
	// 移动端样式
	@media (max-width:1206px){
		.footer{
			width: 100%;
			height: 6.52rem;
			background-color: #1C100B;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			
			.box{
				width: 100%;
				min-height: 5.79rem;
				border-bottom: 0.01rem solid #6D6B6B;
				display: flex;
				flex-wrap: wrap;
				
				.left{
					width: 10rem;
					height:2.79rem ;
					font-size: 0.18rem;
					margin-left: 0.56rem;
					
					.hotline{
						margin-top: 0.65rem;
						color: #CDCDCD;
					}
					.phone{
						margin-top: 0.25rem;
						font-size: 36px;
						color: #CDCDCD;
					}
					.time{
						margin-top: 0.42rem;
						color: #808080;
					}
					.citys{
						color: #808080;
						margin-top: 0.16rem;
					}
				}
				.right{
					// width: 6rem;
					height:2.79rem ;
					display: flex;
					justify-content: space-around;
					margin-left: 0.56rem;
					.pic:nth-child(1){
						margin-right: 0.42rem;
					}
					.pic{
						width: 1.65rem;
						height: 2.02rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						margin-top: 0.41rem;
						img{
							width: 1.65rem;
							height: 1.65rem;
							border: 0.01rem solid #999999;
						}
						span{
							font-size: 0.17rem;
							color: #808080;
							margin-top: 0.27rem;
						}
					}
				}
			}
			.btm{
				font-size: 0.14rem;
				color: #808080;
				margin-top: 0.19rem;
			}
		}
	}
</style>
